import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink" data-id="element-63" data-mp="3gfitaf6445cj">
      <div className="mx-auto max-w-4xl px-5 pb-7 pt-8 text-center" data-id="element-64" data-mp="3gh3sii3dgcgq">
        <p className="font-display text-xl font-black text-plata-soft" data-id="element-65" data-mp="32pfgeet4hnzr">
          Amigurumi Business Pack<span className="align-super text-xs" data-id="element-66" data-mp="36pza18ehm9h5">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/60" data-id="element-67" data-mp="3uesani6215i3">
          El sistema de negocio N°1 para tejedoras emprendedoras de Argentina. Porque crear un
          negocio desde casa no debería costarte todos tus ahorros.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/70" data-id="element-68" data-mp="3lgoocjn8w4p8">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors hover:text-bordo-light" data-id="element-69" data-mp="29z6uqczdolgf">
            <MailIcon className="h-4 w-4 text-plata" aria-hidden="true" data-id="element-70" data-mp="2ew716p053q82" />{' '}
            soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-bordo-light" data-id="element-71" data-mp="3gapf5opniuim">
            <InstagramIcon className="h-4 w-4 text-plata" aria-hidden="true" data-id="element-72" data-mp="3v9b1fhu5q8ey" /> @sigmasmartoficial
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-bordo-light" data-id="element-73" data-mp="3q7bxa5qlf7gy">
            <GlobeIcon className="h-4 w-4 text-plata" aria-hidden="true" data-id="element-74" data-mp="3477jvnjyo2y" /> www.sigmasmart.store
          </a>
        </div>

        <p className="mt-4 whitespace-pre-line font-display text-[18px] italic text-plata-soft" data-id="element-75" data-mp="hrs5lb5klx40">
          {'“Tu emprendimiento con amigurumis\nempieza acá.” 🧶'}
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/40" data-id="element-76" data-mp="qt04nvfwv1z5">
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-77" data-mp="msg8ov72q4el">
            Términos y condiciones
          </a>
          <span aria-hidden="true" data-id="element-78" data-mp="tw5w602sbejk">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-79" data-mp="tt0ayvxa0wt4">
            Política de privacidad
          </a>
          <span aria-hidden="true" data-id="element-80" data-mp="13tkds30g29dg">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-81" data-mp="13sir11a2fyfw">
            Soporte
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/35" data-id="element-82" data-mp="18lbvrp5jb6rz">
          © 2026 Sigma Smart ™ — Todos los derechos reservados. Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}